function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.15 5.218l10.618 10.617c-6.542.955-11.588-3.958-10.618-10.617zm-1-3.829c-4.398 10.774 4.776 19.805 15.444 15.443l-15.444-15.443zm-3.15 22.611h2.949c1-.923 2.004-2 3.551-2s2.551 1.077 3.551 2h2.949l-6.5-6-6.5 6zm11.081-17.493l2.411 2.412c.666-.666.666-1.746 0-2.412s-1.745-.666-2.411 0zm.919-6.507v1.592c3.783 0 6.408 2.584 6.408 6.408h1.592c0-4.734-3.362-8-8-8zm0 3.014v1.605c2.13 0 3.381 1.242 3.381 3.381h1.605c0-3.017-1.966-4.986-4.986-4.986z"
});

var SvgSignal = function SvgSignal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signal.90d19b39.svg";
export { ForwardRef as ReactComponent };